module.exports = __webpack_public_path__ + "static/media/familyWarning.ebe50ab0.svg";